export default __webpack_public_path__ + "dist/media/Safe.b9569797.svg";